import React from "react";
import { useOutletContext } from "react-router-dom";

import { About, Achievements, Blog, Main, MainLion, Prices, Services } from "./pages";
import "./App.css";
import ScrollHandler from "./ScrollHandler";

export default function Home() {
    const { appTheme = "classic" } = useOutletContext() || {};
    const isLionTheme = appTheme === "lion";

    return (
        <div className="mainBlock">
            {!isLionTheme && <ScrollHandler />}
            <section id="main">{isLionTheme ? <MainLion /> : <Main />}</section>
            {!isLionTheme && (
                <>
                    <section id="services"><Services /></section>
                    <section id="prices"><Prices /></section>
                    <section id="aboutus"><About /></section>
                    <section id="achievements"><Achievements /></section>
                    <section id="faq"><Blog /></section>
                </>
            )}
        </div>
    );
}
